const root = 'AppliedMarketplaceFilters'

export const TestId = {
  container: `${root}-container`,
  filterChip: `${root}-filterChip`,
  clearAllFilters: `${root}-clearAllFilters`,
}
